/**
 * Clock with a checkmark on a mango background, indicating an item has been added to the back-in-stock waitlist.
 *
 * @param {Object} props
 * @param {string} [props.className=''] - Additional CSS classes
 * @param {number} [props.width=42] - Icon width and height in pixels
 */
function WaitlistAddedIcon({ className = '', width = 42 }) {
    return (
        <svg
            className={className}
            width={width}
            height={width}
            viewBox="0 0 42 42"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <rect width="42" height="42" rx="21" fill="#F1C34A" />
            <path
                d="M21 15.5V21H25.125M29.25 21C29.25 22.0834 29.0366 23.1562 28.622 24.1571C28.2074 25.1581 27.5997 26.0675 26.8336 26.8336C26.0675 27.5997 25.1581 28.2074 24.1571 28.622C23.1562 29.0366 22.0834 29.25 21 29.25C19.9166 29.25 18.8438 29.0366 17.8429 28.622C16.8419 28.2074 15.9325 27.5997 15.1664 26.8336C14.4003 26.0675 13.7926 25.1581 13.378 24.1571C12.9634 23.1562 12.75 22.0834 12.75 21C12.75 18.812 13.6192 16.7135 15.1664 15.1664C16.7135 13.6192 18.812 12.75 21 12.75C23.188 12.75 25.2865 13.6192 26.8336 15.1664C28.3808 16.7135 29.25 18.812 29.25 21Z"
                stroke="#2D2D2D"
                strokeWidth="1.65"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <g clipPath="url(#waitlist-added-check-clip)">
                <path
                    d="M33.2781 21.5719C33.7857 20.811 34.7822 20.5712 35.573 20.9899L35.7283 21.0826L35.8738 21.1901C36.5644 21.7596 36.7243 22.7715 36.2175 23.5319L31.3425 30.8444C31.0854 31.2297 30.6886 31.497 30.241 31.5924L30.0466 31.6227C29.5182 31.6748 28.9972 31.4853 28.6248 31.1129L25.3748 27.8629C24.6851 27.1732 24.6851 26.0555 25.3748 25.3658C26.0213 24.7195 27.0436 24.6792 27.7371 25.2448L27.8718 25.3658L29.5974 27.0914L33.2781 21.5719Z"
                    fill="#2D2D2D"
                    stroke="#F1C34A"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="waitlist-added-check-clip">
                    <rect width="13" height="13" fill="white" transform="translate(24 19)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default WaitlistAddedIcon;
